import { render } from "./EditReminder.vue?vue&type=template&id=42df6204&scoped=true"
import script from "./EditReminder.vue?vue&type=script&lang=js"
export * from "./EditReminder.vue?vue&type=script&lang=js"

import "./EditReminder.vue?vue&type=style&index=0&id=42df6204&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42df6204"]])

export default __exports__